import * as Action from "./../Actions/action";
import InitialState from "./../../../Constants/initialState";
import cloneDeep from "lodash/cloneDeep";
export default function DepartmentReducer(state = InitialState.department, action) {
    switch (action.type) {
        case Action.getDepartment:
            let s = cloneDeep(state);
            s.list = action.payload.list;
            s.count = action.payload.count;
            return s;
        case Action.AppendDepartmentList:
            var s2 = cloneDeep(state);
            var arr = s2.list.slice();
            s2.list = arr.concat(action.payload.list);
            return s2;
        case Action.getDepartmentDetail:
            let s3 = cloneDeep(state);
            s3.detail = action.payload.detail;
            return s3;
        default:
            return state;
    }
}